'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SearchView: {
        displayName: 'SearchView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Search/default/SearchView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SearchView = _wrapComponent('SearchView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(SearchView, _Component);

    function SearchView() {
        (0, _classCallCheck3.default)(this, SearchView);
        return (0, _possibleConstructorReturn3.default)(this, (SearchView.__proto__ || (0, _getPrototypeOf2.default)(SearchView)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                activePage = _props.activePage,
                count = _props.count,
                limit = _props.limit,
                products = _props.products,
                handleChangePage = _props.handleChangePage,
                lang = _props.lang;


            var CategoryView = _helpers.ThemeHelper.getViewForContainer('Category');
            var resultTitle = lang['store.search.result'] + ":";

            return _react3.default.createElement(CategoryView, {
                activePage: activePage,
                count: count,
                limit: limit,
                products: products,
                title: resultTitle,
                handleChangePage: handleChangePage,
                lang: lang
            });
        }
    }]);
    return SearchView;
}(_react2.Component), _class.propTypes = {
    products: _react2.PropTypes.array.isRequired,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = SearchView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Search/default/SearchView.jsx
// module id = 1846
// module chunks = 0